'use client';

import { useState } from 'react';

import type { OfferCardProps } from '@wwe-portal/ui/features/offer';
import type { OfferDialogProps } from '@wwe-portal/ui/features/club-store/dialog/offer-dialog';
import type { MissionRewardCardProps } from '@wwe-portal/ui/features/club-store/milestone/mission-reward-card';
import type { SubscriptionTier } from '@wwe-portal/entities/subscription.type';

export const useOfferDialogState = ({
  handleBuy,
  onReferSubscription,
}: {
  handleBuy?: (data: {
    tier: SubscriptionTier;
    offerData: OfferCardProps;
  }) => void;
  onReferSubscription?: () => void;
}) => {
  const [data, setData] = useState<MissionRewardCardProps | undefined>();
  const props: OfferDialogProps & {
    setRewardCardData: (value: MissionRewardCardProps) => void;
  } = {
    onClose: () => {
      setData(undefined);
    },
    open: data !== undefined,
    data,
    setRewardCardData: (value: MissionRewardCardProps) => {
      setData(value);
    },
    handleBuy: (offer) => handleBuy?.(offer),
    onReferSubscription,
  };
  return props;
};
